<mlp-ng-sub-section
    class="sg-divider__gradient py-3 py-md-0"
    (dropdownStatus)="dropdownStatus($event)"
    [ngClass]="{ '-no-gradient': dropdownIsOpen }"
    *ngIf="subNav"
    [section]="subNav"
></mlp-ng-sub-section>

<router-outlet></router-outlet>
